module.exports = __webpack_public_path__ + "img/paas_d.e27710b.svg";